<template>
  <svg
    v-if="props.theme === 'v1'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="7.5"
    viewBox="0 0 24 7.5"
  >
    <path
      :fill="props.fillBorder"
      transform="translate(-0.69 1.16)"
      d="M9.17,5.17,6.34,2.34A8,8,0,0,0,.69,0H23.31a8,8,0,0,0-5.65,2.34L14.83,5.17A4,4,0,0,1,9.17,5.17Z"
    />

    <path
      :fill="props.fill"
      transform="translate(-0.69 1.16)"
      d="M9.17,4.19,6.34,1.26A7.86,7.86,0,0,0,.69-1.16H23.31a7.86,7.86,0,0,0-5.65,2.42L14.83,4.19A3.9,3.9,0,0,1,9.17,4.19Z"
    />
  </svg>

  <svg
    v-else-if="theme === 'v2'"
    width="32"
    height="20"
    viewBox="0 0 32 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 20L2.14359 6.5L29.8564 6.5L16 20Z" :fill="props.fillBorder" />
    <path d="M16 18L2.14359 4.5L29.8564 4.5L16 18Z" :fill="props.fill" />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'IconsToolTip'
})

const props = defineProps({
  theme: {
    type: String,
    default: 'v1',
    validator: value => ['v1', 'v2'].includes(value)
  },

  fillBorder: {
    type: String,
    default: '#ffffff'
  },

  fill: {
    type: String,
    default: '#ffffff'
  }
})
</script>
